import { render, staticRenderFns } from "./DuplicateFeature.vue?vue&type=template&id=4aed6061&scoped=true"
import script from "./DuplicateFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateFeature.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed6061",
  null
  
)

export default component.exports